import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import TagForm from './TagForm';
import { TableAddIcon } from '../../../../Icons';

var DatabaseSelectColumnOptions =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DatabaseSelectColumnOptions, _React$PureComponent);

  function DatabaseSelectColumnOptions() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DatabaseSelectColumnOptions);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DatabaseSelectColumnOptions)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onAddSelectOption", function (event) {
      _this.props.database.addSelectOption(_this.props.column.key, {
        label: ''
      });
    });

    return _this;
  }

  _createClass(DatabaseSelectColumnOptions, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          database = _this$props.database,
          column = _this$props.column;
      var options = database.getColumnSelectOptions(column.key);
      return React.createElement("div", {
        className: classNames('slite-design-system', 'shade-05 padding-bottom-medium padding-horizontal-medium background-white')
      }, React.createElement("div", {
        className: "padding-bottom-normal font-weight-medium"
      }, 'Select options'), React.createElement("div", null, Object.values(options).map(function (option) {
        return React.createElement(TagForm, {
          key: option.key,
          database: database,
          column: column,
          option: option
        });
      }), React.createElement("div", {
        onClick: this.onAddSelectOption,
        className: "flexbox pointer shade-30 shade-20-on-hover"
      }, React.createElement(TableAddIcon, {
        className: "flexbox-no-shrink margin-vertical-smaller margin-right-small",
        size: 19
      }), React.createElement("div", {
        className: "flexbox-grow font-weight-semibold padding-vertical-smaller"
      }, "Add an option"))));
    }
  }]);

  return DatabaseSelectColumnOptions;
}(React.PureComponent);

_defineProperty(DatabaseSelectColumnOptions, "propTypes", {
  database: PropTypes.object.isRequired,
  column: PropTypes.object.isRequired
});

export default DatabaseSelectColumnOptions;